// extracted by mini-css-extract-plugin
export var background = "_5i-0";
export var container = "_5i-1";
export var contentItem = "_5i-7";
export var extendedWarranty = "_5i-5";
export var link = "_5i-d";
export var modal = "_5i-b";
export var modalCloseButton = "_5i-9";
export var modalContent = "_5i-3";
export var modalContentMain = "_5i-6";
export var modalImageLogo = "_5i-8";
export var modalLogo = "_5i-a";
export var modalSideImage = "_5i-4";
export var preview = "_5i-c";
export var redoModal = "_5i-2";